










import { Component, Prop } from 'vue-property-decorator';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Card from '@/models/Accounts/Shared/Cards/Card';
import AppConsts from '@/lib/appConstants';

@Component({ name: 'CardExample' })
export default class extends SaascadaVue {

    @Prop({required: true})
    currentCard: Card;

    AppConsts = AppConsts;

    get institutionName() {
        return AuthModule.me.institution.name;
    }

}
